export const LOCALE_COOKIE = 'locale';
export const QUERY_PARAM = 'lang';
export const READ_LOCALE_COOKIES = [LOCALE_COOKIE, 'international'] as const;
